import { canAccessResource } from '../../../authorization/canAccessResource';
import { globalpermissions } from '../../../Services/Permission.js';

/**
 * Whether the current user may create a new table (lead form) in a workspace.
 *
 * AuthZ v2: campaign-level edit grant + module edit on ProposalInfo/AccountInfo
 * (mirrors backend is_user_permitted CREATE → campaign edit).
 *
 * Legacy: profile feature `can_create_web_form`.
 *
 * @param {import('../../../authorization/types/authz.types').AuthzContext|null|undefined} authz
 * @param {{ workspaceId?: string, accountId?: string, userInfo?: object|null, legacyUserHasPermission?: (permissions: string[]) => boolean }} params
 */
export function canCreateWorkspaceTable(authz, {
  workspaceId,
  accountId,
  userInfo,
  legacyUserHasPermission,
} = {}) {
  if (!workspaceId) {
    return false;
  }

  if (authz?.isFullAccess) {
    return true;
  }

  if (!authz?.isAuthzV2Enabled) {
    if (typeof legacyUserHasPermission === 'function') {
      return legacyUserHasPermission([globalpermissions?.leadDashboard?.createWebForm]);
    }

    const legacyPermissions = userInfo?.profile?.permissions || {};
    return Boolean(legacyPermissions[globalpermissions?.leadDashboard?.createWebForm]);
  }

  return canAccessResource(authz, {
    type: 'campaign',
    id: workspaceId,
    action: 'edit',
    accountId,
  });
}
